<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="container border rounded" style="background-color:powderblue;">
      <div class="row justify-content-md-center">
        <span *ngIf="Item.ID != -1" style="white-space: pre;">{{ "Ime: " + Ime+ " | " +" Prezime: " +
          Prezime}}</span>
        <span *ngIf="Item.ID == -1" translate="ZAPOSLENI.NEW"></span>
      </div>
    </div>
    <div class="row tabs-cont" #tabsCont>
      <div class="col-md-12 h-100">
        <ngb-tabset #tabSet="ngbTabset" [destroyOnHide]="false" id="tabset">
          <!-- <ngb-tabset #tabSet="ngbTabset" [destroyOnHide]="false" id="tabset"  [activeId]="active"> -->

          <ngb-tab title="{{'ZAPOSLENI.BASIC'| translate}}" id="tbList">
            <ng-template ngbTabContent>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="form-group row">
                        <div class="col-md-12">
                          <yt-dropdown-picklist
                          [ModelName]="'osoba'"
                          [GetName]="'get'"
                          [ModelProperty]="'Ime,Prezime'"
                          formControlName="OsobaID"
                          [Label]="'ZAPOSLENI.OSOBA.SINGULAR'"
                           [ngClass]="{
                             'is-invalid':
                               submitted && fc.OsobaID.invalid
                           }"
                           #autofocus
                           [AutoSelect]="true"
                           [AllowAddNew]="true"
                           (OnItemSelected)="onOsobaSelect($event)"
                         >
                         </yt-dropdown-picklist>
                          <div class="form-error" *ngIf="submitted && fc.OsobaID.invalid">
                            <span *ngFor="let validation of errorMessages.OsobaID">
                              <span class="error-message" *ngIf="fc.OsobaID.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="form-group row">
                        <div class="col-md-12">
                          <yt-input
                          [Type]="'text'"
                          [Label]="'ZAPOSLENI.IME.SINGULAR'"
                          name="txtIme"                  
                          #autofocus
                          formControlName="Ime"                
                          [ngClass]="{'is-invalid': submitted && fc.Ime.invalid}">
                        </yt-input>
                          <div class="form-error" *ngIf="submitted && fc.Ime.invalid">
                            <span *ngFor="let validation of errorMessages.Ime">
                              <span class="error-message" *ngIf="fc.Ime.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="form-group row">
                        <div class="col-md-12">
                          <yt-input
                          [Type]="'text'"
                          [Label]="'ZAPOSLENI.PREZIME.SINGULAR'"
                          name="txtPrezime"                  
                          #autofocus
                          formControlName="Prezime"                
                          [ngClass]="{'is-invalid': submitted && fc.Prezime.invalid}">
                        </yt-input>
                          <div class="form-error" *ngIf="submitted && fc.Prezime.invalid">
                            <span *ngFor="let validation of errorMessages.Prezime">
                              <span class="error-message" *ngIf="fc.Prezime.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="form-group row">
                        <div class="col-md-12">
                          <yt-input
                          [Type]="'text'"
                          [Label]="'ZAPOSLENI.DEVOJACKO.SINGULAR'"
                          name="txtDevojacko"                  
                          #autofocus
                          formControlName="Devojacko"                
                          [ngClass]="{'is-invalid': submitted && fc.Devojacko.invalid}">
                        </yt-input>
                          <div class="form-error" *ngIf="submitted && fc.Devojacko.invalid">
                            <span *ngFor="let validation of errorMessages.Devojacko">
                              <span class="error-message" *ngIf="fc.Devojacko.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="form-group row">
                        <div class="col-md-12">
                          <yt-input
                          [Type]="'text'"
                          [Label]="'ZAPOSLENI.IMEOCA.SINGULAR'"
                          name="txtImeOca"                  
                          #autofocus
                          formControlName="ImeOca"                
                          [ngClass]="{'is-invalid': submitted && fc.ImeOca.invalid}">
                        </yt-input>
                          <div class="form-error" *ngIf="submitted && fc.ImeOca.invalid">
                            <span *ngFor="let validation of errorMessages.ImeOca">
                              <span class="error-message" *ngIf="fc.ImeOca.hasError(validation.type)"><span
                                  translate="{{validation.message}}"></span></span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-lg-2">
                            <div class="form-group row">
                              <div class="col-md-12">
                                <yt-input
                                [Type]="'text'"
                                [Label]="'ZAPOSLENI.JMBG.SINGULAR'"
                                name="txtJmbg"                  
                                #autofocus
                                formControlName="Jmbg"                
                                [ngClass]="{'is-invalid': submitted && fc.Jmbg.invalid}">
                              </yt-input>
                                <div class="form-error" *ngIf="submitted && fc.Jmbg.invalid">
                                  <span *ngFor="let validation of errorMessages.Jmbg">
                                    <span class="error-message" *ngIf="fc.Jmbg.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <yt-dropdown-picklist 
                              [ModelName]="'pol'" 
                              [GetName]="'get'" 
                              [ModelProperty]="'Naziv'" 
                              [OrderBy]="'Naziv'"
                              [AllowAddNew]="false" 
                              formControlName="PolID" 
                              [Label]="'OSOBA.POL.SINGULAR'">
                            </yt-dropdown-picklist>
                            <div class="form-error" *ngIf="submitted && fc.PolID.invalid">
                              <span *ngFor="let validation of errorMessages.PolID">
                                <span class="error-message" *ngIf="fc.PolID.hasError(validation.type)">
                                  <span translate="{{validation.message}}"></span>
                                </span>
                              </span>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <yt-fw-date-picker-popup
                            formControlName="DatumRodj"
                            name="txtDatum" 
                            [Label]="'ZAPOSLENI.DATUMRODJENJA.SINGULAR'"
                            [ngClass]="{'is-invalid': submitted && fc.DatumRodj.invalid}">
                      </yt-fw-date-picker-popup>
                            <div class="form-error" *ngIf="submitted && fc.DatumRodj.invalid">
                              <span *ngFor="let validation of errorMessages.DatumRodj">
                                <span class="error-message" *ngIf="fc.DatumRodj.hasError(validation.type)">
                                  <span translate="{{validation.message}}"></span>
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </ng-template>
          </ngb-tab>
        </ngb-tabset>
      </div>
    </div>
  </div>
</form>
